var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress",style:('height:20px')},[_c('div',{staticClass:"progress-bar bg-primary",style:('width:'+_vm.progress+'%'),attrs:{"role":"progressbar","aria-valuenow":_vm.progress,"aria-valuemin":"0","aria-valuemax":"100"}},[_c('span',[_c('b',[_vm._v(_vm._s(_vm.progress))]),_vm._v(" %\n        ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }